export class AppState {
	private _postalCode: string | undefined;
	private _dataSourceId: string | undefined;
	private _proxyUrl: string | undefined;
	private _adId: string | undefined;
	private _adCoordinates: [number, number] | undefined;
	private _center: [number, number] | undefined;
	private _zoomLevel: number | undefined;

	constructor() {
		this._postalCode = this.getQueryParamFromState("postalCode");
		this._dataSourceId = this.getQueryParamFromState("dataSourceId");
		this._proxyUrl = this.getQueryParamFromState("proxyUrl");
		this._adId = this.getQueryParamFromState("adId");
		this._adCoordinates = this.getCoordinatesFromQueryParam("adCoordinates");
		this._center = this.getCoordinatesFromQueryParam("center");
		this._zoomLevel = this.getZoomLevelFromState();
	}

	private getQueryParamFromState(param: string): string | undefined {
		const scriptTag = document
			.querySelector("map-preview-podlet-isolated")
			?.shadowRoot?.querySelector("script[data-map-podlet-state]");
		if (scriptTag) {
			const state = JSON.parse(scriptTag.textContent || "");
			return state[param] ?? undefined;
		}
	}

	private getCoordinatesFromQueryParam(param: string): [number, number] | undefined {
		const scriptTag = document
			.querySelector("map-preview-podlet-isolated")
			?.shadowRoot?.querySelector("script[data-map-podlet-state]");
		if (scriptTag) {
			const state = JSON.parse(scriptTag.textContent || "");
			return state[param] ?? undefined;
		}
	}

	private getZoomLevelFromState(): number | undefined {
		const scriptTag = document
			.querySelector("map-preview-podlet-isolated")
			?.shadowRoot?.querySelector("script[data-map-podlet-state]");
		if (scriptTag) {
			const state = JSON.parse(scriptTag.textContent || "");
			return state.zoomLevel;
		}
	}

	get postalCode(): string | undefined {
		return this._postalCode;
	}

	get dataSourceId(): string | undefined {
		return this._dataSourceId;
	}

	get proxyUrl(): string | undefined {
		return this._proxyUrl;
	}

	get adId(): string | undefined {
		return this._adId;
	}

	set adId(adId: string | undefined) {
		this._adId = adId;
	}

	get adCoordinates(): [number, number] | undefined {
		return this._adCoordinates;
	}

	set adCoordinates(adCoordinates: [number, number] | undefined) {
		this._adCoordinates = adCoordinates;
	}

	get center(): [number, number] | undefined {
		return this._center;
	}

	set center(center: [number, number] | undefined) {
		this._center = center;
	}

	get zoomLevel(): number | undefined {
		return this._zoomLevel;
	}

	set zoomLevel(zoomLevel: number | undefined) {
		this._zoomLevel = zoomLevel;
	}
}
